import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { Star } from "@mui/icons-material";
import { BaseBanner } from "./BaseBanner";

export interface Product {
  id: string;
  name: string;
  price: number;
  originalPrice?: number;
  image: string;
  rating?: number;
  reviewCount?: number;
  discount?: number;
  badge?: string;
  href: string;
}

export interface BannerProps {
  products: Product[];
  autoSlide?: boolean;
  slideInterval?: number;
  showDots?: boolean;
  ctaText?: string;
  onProductClick?: (product: Product) => void;
  onCtaClick?: () => void;
}

export const Banner300x250: React.FC<BannerProps> = ({
  products,
  autoSlide = true,
  slideInterval = 10000,
  ctaText = "Купи сега",
  onProductClick = ({ id, href }) => {
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "temu_click", {
        event_category: "ad",
        event_label: "temu_button",
        value: id,
      });
    }
    window.open(href, "_blank");
  },
  onCtaClick,
}) => {
  return (
    <BaseBanner
      products={products}
      // minWidth={300}
      height={250}
      autoSlide={autoSlide}
      slideInterval={slideInterval}
    >
      {(product) => (
        <Box
          onClick={() => onProductClick?.(product)}
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            color: "white",
            p: 2,
          }}
        >
          {/* TEMU Header with Ad Label */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                color: "white",
                textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
              }}
            >
              TEMU
            </Typography>
            <Chip
              label="Реклама"
              size="small"
              sx={{
                backgroundColor: "rgba(255,255,255,0.9)",
                color: "#ff6b35",
                fontSize: "0.6rem",
                height: 16,
                fontWeight: "bold",
              }}
            />
          </Box>

          <Box
            sx={{ display: "flex", alignItems: "flex-start", gap: 2, flex: 1 }}
          >
            <Box
              component="img"
              src={product.image}
              alt={product.name}
              sx={{
                width: 80,
                height: 80,
                objectFit: "cover",
                borderRadius: 1,
                backgroundColor: "white",
              }}
            />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              {product.badge && (
                <Chip
                  label={product.badge}
                  size="small"
                  sx={{
                    backgroundColor: "#ff1744",
                    color: "white",
                    fontSize: "0.7rem",
                    height: 20,
                    mb: 1,
                  }}
                />
              )}
              <Typography
                variant="h6"
                sx={{
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  lineHeight: 1.2,
                  mb: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                }}
              >
                {product.name}
              </Typography>
              {product.rating && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 1,
                  }}
                >
                  <Star sx={{ fontSize: 14, color: "#ffd700" }} />
                  <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
                    {product.rating} ({product.reviewCount})
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 1,
            }}
          >
            <Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  variant="h5"
                  sx={{ fontWeight: "bold", fontSize: "1.2rem" }}
                >
                  {product.price} ден
                </Typography>
                {product.discount && (
                  <Chip
                    label={`-${product.discount}%`}
                    size="small"
                    sx={{
                      backgroundColor: "#ff1744",
                      color: "white",
                      fontSize: "0.7rem",
                      height: 20,
                      fontWeight: "bold",
                    }}
                  />
                )}
              </Box>
              {product.originalPrice && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography
                    variant="caption"
                    sx={{
                      textDecoration: "line-through",
                      opacity: 0.8,
                      fontSize: "0.7rem",
                    }}
                  >
                    {product.originalPrice} ден
                  </Typography>
                  {product.discount && product.originalPrice && (
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#ffeb3b",
                        fontSize: "0.7rem",
                        fontWeight: "bold",
                      }}
                    >
                      Заштедете{" "}
                      {(product.originalPrice - product.price).toFixed(2)} ден
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
            <Box
              onClick={(e) => {
                e.stopPropagation();
                onCtaClick?.();
              }}
              sx={{
                backgroundColor: "white",
                color: "#ff6b35",
                px: 2,
                py: 0.5,
                borderRadius: 1,
                fontWeight: "bold",
                fontSize: "0.8rem",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              {ctaText}
            </Box>
          </Box>
        </Box>
      )}
    </BaseBanner>
  );
};
